import React, { useState } from "react";
import Input from "../../atoms/Input";
import Button from "../../atoms/Button";
import { contactUs } from "../../../utils/API/contactUs";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import AcceptPopUp from "../../molecules/AcceptPopUp";
import { useNavigate } from "react-router-dom";

const ContactUsBody = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [errors, setErrors] = useState({});
  // const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [formSubmitted, setFormSubmitted] = useState(false);

  const validateEmail = (email) => {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  };

  const handleSubmit = async () => {
    const newErrors = {};
    if (!firstName) newErrors.firstName = "First Name is required";
    if (!lastName) newErrors.lastName = "Last Name is required";
    if (!email) {
      newErrors.email = "Email is required";
    } else if (!validateEmail(email)) {
      newErrors.email = "Invalid email format";
    }
    if (!phoneNumber) newErrors.phoneNumber = "Phone Number is required";
    if (!countryCode) newErrors.countryCode = "Country code is required";
    if (!message) newErrors.message = "Please Write a Message";

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      try {
        const formData = {
          first_name: firstName,
          last_name: lastName,
          email: email,
          contact_number: {
            phone_no: phoneNumber,
            country_code: countryCode,
          },
          message: message,
        };
        // console.log(formData);
        await contactUs(formData, dispatch);
        setFormSubmitted(true);
      } catch (error) {
        toast.error(error.message);
      }
    }
  };

  return (
    <div className=" h-full ">
      <div className="bg-blue-100 pt-8">
        <div
          className="flex justify-center h-[26rem] items-center pt-12 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: "url('/images/contactusheader.png')",
            backgroundSize: "100%",
          }}
        >
          <div className="py-20  bg-opacity-70">
            <div className="text-[120px] flex font-normal justify-center">
              CONTACT <span className="text-blue-800">US</span>
            </div>
          </div>
        </div>
      </div>
      <div className="flex w-full h-full bg-grey-100 mb-8 py-4 ">
        <div className="py-8 pr-28 pl-12 h-fit  shadow-md bg-white mx-20 rounded-md">
          <div className="flex justify-start gap-4">
            <label htmlFor="firstName" className="text-sm font-semibold">
              First Name
              <Input
                type="text"
                variant="secondary"
                className="w-72"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
              {errors.firstName && (
                <p className="text-red-500">{errors.firstName}</p>
              )}
            </label>
            <label htmlFor="lastName" className="text-sm font-semibold">
              Last Name
              <Input
                type="text"
                variant="secondary"
                className="w-72"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
              {errors.lastName && (
                <p className="text-red-500">{errors.lastName}</p>
              )}
            </label>
          </div>
          <div className="flex justify-start gap-4 my-16">
            <label htmlFor="email" className="text-sm font-semibold">
              Email
              <Input
                type="email"
                variant="secondary"
                className="w-72"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              {errors.email && <p className="text-red-500">{errors.email}</p>}
            </label>
            <label htmlFor="phoneNumber" className="text-sm font-semibold">
              Phone No.
              <div className="flex gap-2">
                <Input
                  type="number"
                  variant="secondary"
                  className="w-14"
                  value={countryCode}
                  onChange={(e) => setCountryCode(e.target.value)}
                />
                <Input
                  type="number"
                  variant="secondary"
                  className="w-56"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                />
              </div>
              <div>
                {errors.phoneNumber && (
                  <p className="text-red-500">{errors.phoneNumber}</p>
                )}
                {errors.countryCode && (
                  <p className="text-red-500">{errors.countryCode}</p>
                )}
              </div>
            </label>
          </div>

          <div className="py-6">
            <label
              htmlFor="firstName"
              className="text-sm text-black font-semibold"
            >
              Message
              <Input
                type="text"
                variant="secondary"
                placeHolder="Write a message.."
                className="w-full"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
            </label>
            {errors.message && (
              <p className="text-sm text-red-500 font-semibold">
                {errors.message}
              </p>
            )}
          </div>
          <div className="flex justify-end py-4">
            <Button
              color="blue"
              varient="secondary"
              className="text-white w-full rounded-md px-5 py-2"
              onClick={handleSubmit}
            >
              Send Message
            </Button>
          </div>
        </div>
        <div className="mr-8">
          <img src="/images/contactus.svg" alt="contact us" />
        </div>
      </div>

      <div className="flex justify-center my-8 px-10">
        <iframe
          title="Office Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3509.412735575694!2d77.03963617549586!3d28.406800394295637!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d2344b74070ed%3A0x4681751e5971dcf0!2sOFFSET%20GLOBAL%20TECHNOLOGIES%20PRIVATE%20LIMITED!5e0!3m2!1sen!2sin!4v1722916355468!5m2!1sen!2sin"
          className="w-full h-[296px] border-0"
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div>
      <div className=" bg-grey-100 rounded-lg  flex pl-24 pb-10">
        <div className="w-1/3">
          <h2 className="text-[#4361EE]  font-bold text-[30px]">Address</h2>
          <div className="font-medium text-[14px]">
            {" "}
            <p>112, Vipul Trade Center. Sector -48, </p>
            <p>Gurugram, Haryana - 122018. INDIA</p>
          </div>
        </div>
        <div className="w-1/3">
          <h2 className="text-[#4361EE]  font-bold text-[30px]">Contact</h2>
          <div className="font-medium text-[14px]">
            {" "}
            <p>1800 572 2929</p>
            <p> info@offsetgo.earth</p>
          </div>
        </div>
        <div className="w-1/3">
          <h2 className="text-[#4361EE] font-bold text-[30px]">
            Opening Hours
          </h2>
          <div className="font-medium text-[14px]">
            {" "}
            <div className="flex gap-x-12">
              <p>Mon - Sat </p> <p>9:30-6:30</p>
            </div>
            <div className="flex gap-x-24">
              <p>Sun</p>
              <p>Off</p>
            </div>
          </div>
        </div>
      </div>
      {formSubmitted && (
        <AcceptPopUp
          open={formSubmitted}
          isRequiredColor={"green"}
          isRequiredCancelButton={false}
          title={"Thank you for reaching out!"}
          statusType={"We’ll get back to you shortly"}
          okButtonText={"Go to Home"}
          onOk={() => navigate("/")}
        />
      )}
    </div>
  );
};

export default ContactUsBody;
